import { useState } from "react";
import { apiCall } from "../api";
import { useLoader } from "../contexts/LoaderContext";
import { RequestConfig } from "../api";
import { useNavigate } from "react-router-dom";
import { useContactType } from "../contexts/ContactContext";
import { useVendorType } from "../contexts/VendorContext";

interface FormHandlingProps{
  requestType:RequestConfig;
  data?: { [key: string]: any };
  params?:object;
  urlParams?:{ [key: string]: string; };
  disableNav?:boolean

}

function removeProperty(obj:any, propToRemove:string) {
  // Destructure the property to remove and gather the rest properties into `rest`
  const { [propToRemove]: _, ...rest } = obj;
  // Return the new object without the specified property
  return rest;
}

export const useFormHandling = ({requestType,data={},params={},urlParams={}}:FormHandlingProps) => {
  const { setLoading } = useLoader();
  const navigate = useNavigate()
  const contactType = useContactType();
  const vendorType = useVendorType();

  const [formValues, setFormValues] = useState<{ [key: string]: any }>({});
  const [formValidFields, setFormValidFields] = useState<{ [key: string]: boolean }>({});
  const [serverRes, setServerRes] = useState<ApiResponse | null>(null);

  const handleInputChange = (name: string, value: any, valid: boolean) => {
   
    setFormValidFields({ ...formValidFields, [name]: valid });
    if(value==="" || value===null){
      setFormValues((prevForm) => (removeProperty(prevForm,name)));
    } else {
      setFormValues((prevForm) => ({
        ...prevForm,
        [name]: value
    }));
    }
      
  };

  const handleClick = async (forceParams?:any,forceUrlParams?:any) => {

    
    
    const validationArr = Object.values(formValidFields);
  
    if ( validationArr.includes(false)) return;
    const responseData = await apiCall({ requestType, data:{...formValues,...data},params:forceParams || params,urlParams:forceUrlParams || urlParams }, setLoading,contactType,vendorType,navigate);
    setServerRes(responseData);
    return responseData;
  };



  const handleFormClick = async (forceParams?:any,forceUrlParams?:any) => {
        
    const validationArr = Object.values(formValidFields);
    console.log(validationArr,"validationArr")  
  
    if ( validationArr.includes(false)) return;

    const formData = new FormData();

    Object.entries(formValues).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((file, i) => {
        formData.append(`${key}[${i}]`, file);
      });
    } else {
      formData.append(key, value);
    }
  });
  for (let i in data) {
    formData.append(i, data[i]);

  }
  


    const responseData = await apiCall({ requestType, data:formData,params:forceParams || params,urlParams:forceUrlParams || urlParams }, setLoading,contactType,vendorType,navigate);
    setServerRes(responseData);
    return responseData;
  };


  return { handleInputChange, handleClick,handleFormClick, serverRes,formValues,setFormValues,setServerRes };
};
